import { z } from 'zod/v4';

const googleLoginCredentialMessageSchema = z.object({
    credential: z.string(),
    select_by: z.string(),
    clientId: z.string(),
});
export type GoogleLoginCredentialResponse = z.infer<typeof googleLoginCredentialMessageSchema>;

export function isGoogleLoginCredentialResponse(obj: unknown): obj is GoogleLoginCredentialResponse {
    return googleLoginCredentialMessageSchema.safeParse(obj).success;
}
